import { render, staticRenderFns } from "./aboutUS.vue?vue&type=template&id=73c67dd4&scoped=true&"
import script from "./aboutUS.vue?vue&type=script&lang=js&"
export * from "./aboutUS.vue?vue&type=script&lang=js&"
import style0 from "./aboutUS.vue?vue&type=style&index=0&id=73c67dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c67dd4",
  null
  
)

export default component.exports